import ModelContainer from "@core/scripts/components/model-container";
import AvailabilityStatusMapper from "../helper/availability-status-mapper";

function createDisplayProductDetailsEvent(product, style, item, itemOption) {
    const averageRating = ModelContainer.get("averageRating");
    return {
        ...resolveInitialData(product, style, item, itemOption),
        rating: averageRating,
    };
}

function createAddToCartEvent(product, style, item, itemOption, ranking, filterTrackingValue, pageViewId) {
    return {
        ...resolveInitialData(product, style, item, itemOption),
        quantity: 1,
        ranking: ranking,
        shopFilter: filterTrackingValue,
        pageViewId: pageViewId
    };
}

function resolveInitialData(product, style, item, itemOption) {
    const styleId = product?.styleId;
    const masterstyleid = product?.masterStyleId;
    const price = resolvePrice(product, style, item, itemOption);
    const unifiedPrice = price?.unified;
    const unifiedFormerPrice = price?.unifiedFormer;
    const currency = unifiedPrice?.currencyCode;
    const displayedPrice = unifiedPrice ? unifiedPrice.value : 0;
    const formerPrice = unifiedFormerPrice ? unifiedFormerPrice.value : 0;
    const itemOptionName = itemOption?.name;
    const articleNumber = item?.itemNumber;
    const availability = (itemOption || item || style || product)?.availability;
    const availabilityText = AvailabilityStatusMapper.mapToAvailabilityStatus(availability);
    return {
        styleId,
        masterstyleid,
        strikeOutPrice: formerPrice,
        displayedPrice,
        currency,
        artNr: articleNumber,
        artGr: itemOptionName,
        availability: availabilityText
    };
}

function resolvePrice(product, style, item, itemOption) {
    return (itemOption || item || style || product)?.price;
}

export default {
    createDisplayProductDetailsEvent,
    createAddToCartEvent
}